import { render, staticRenderFns } from "./enrollmentEdit.vue?vue&type=template&id=05b2b1e6&scoped=true&lang=html&"
import script from "./enrollmentEdit.vue?vue&type=script&lang=js&"
export * from "./enrollmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./enrollmentEdit.vue?vue&type=style&index=0&id=05b2b1e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b2b1e6",
  null
  
)

export default component.exports